import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { M_TRA_SIGN_Schema } from './M_TRA_SIGN_Schema';

/**
 * 모바일 QR 참석 등록 (임시 세션 1건 INSERT)
 * 서버: SaveTraCustom02SessionSign (AllowAnonymous)
 */
export const SaveLogicTraCustom02SessionSign1 = async ({
  sessionId,
  userNm,
  jobType,
  tpaUserId,
  remark,
}) => {
  const payload = mapParamsBySchema(
    M_TRA_SIGN_Schema.mapper.saveTraCustom02SessionSign1,
    { sessionId, userNm, jobType, tpaUserId, remark }
  );
  return apiRequest(
    'post',
    Global.urls.Training.saveTraCustom02SessionSign,
    payload
  );
};

